export default "__VITE_ASSET__NADXoo71__"